import {Component, Input, OnInit} from '@angular/core';
import {RbbDocument} from '../../../../../../model/vorhersagen/rbb-document';
import {FirebaseService} from '../../../../../../service/firebase/firebase.service';

@Component({
  selector: 'app-rbb',
  templateUrl: './rbb.component.html'
})
export class RbbComponent implements OnInit {

  rbbDocument?: RbbDocument;
  selectedIndex: number = 0;
  isLoading = false;
  @Input()
  selectedBundesland: string;

  constructor(private firebaseService: FirebaseService) {
  }

  ngOnInit(): void {
    this.isLoading = true;

    this.firebaseService.getTerminalTexteRbb()
      .subscribe(rbbDocument => {
        this.rbbDocument = rbbDocument;
      }).add(() => this.isLoading = false);
  }
}
